import { KiteIcon } from '@kite/react-kite';
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import React, { FC } from 'react';
import { SmartLink } from '../SmartLink/SmartLink';
import './LeaderImageCard.scss';

export interface ILeaderImageCardProps {
    name: string;
    position: string;
    secondary?: string;
    image: {
        localFile: ImageDataLike;
        alt: string;
    };
    pageUrl: string;
    topLeader?: boolean;
    featuredCopy?: string;
    maxWidth?: number;
    isLeadershipPage?: boolean;
}
export const LeaderImageCard: FC<{ inputs: ILeaderImageCardProps }> = ({
    inputs: {
        name,
        position,
        secondary,
        image,
        pageUrl,
        topLeader,
        featuredCopy,
        maxWidth,
        isLeadershipPage = false,
    },
}) => {
    const MainHeading = isLeadershipPage
        ? (`h3` as keyof JSX.IntrinsicElements)
        : (`h4` as keyof JSX.IntrinsicElements);

    const SubHeading = isLeadershipPage
        ? (`h4` as keyof JSX.IntrinsicElements)
        : (`h5` as keyof JSX.IntrinsicElements);

    if (topLeader) {
        return (
            <div
                className="top-leader-image-card"
                style={{ maxWidth: `${maxWidth}px` }}
            >
                <GatsbyImage
                    image={getImage(image.localFile)}
                    alt={image.alt}
                />
                <div className="top-leader-image-card__text-wrapper">
                    <h2
                        aria-label={`${name}, ${position} ${
                            secondary ? secondary : ``
                        }`}
                        className="top-leader-image-card__header"
                    >
                        {name}
                        <div className="top-leader-image-card__position">
                            <small aria-hidden>{position}</small>
                            {secondary && (
                                <small aria-hidden>{secondary}</small>
                            )}
                        </div>
                    </h2>
                    {featuredCopy && (
                        <p className="top-leader-image-card__featured-copy">
                            {featuredCopy}
                        </p>
                    )}
                    <SmartLink
                        url={pageUrl}
                        ariaLabel={`View ${name}'s Leadership Bio`}
                        classNames={[`top-leader-image-card__link`]}
                    >
                        View Bio
                        <KiteIcon icon="ki-arrow-right" size="1rem" />
                    </SmartLink>
                </div>
            </div>
        );
    }
    return (
        <div className="leader-image-card">
            <GatsbyImage image={getImage(image.localFile)} alt={image.alt} />
            <div className="leader-image-card__text-wrapper">
                <div className="leader-image-card__headings">
                    <MainHeading className="leader-image-card__header">
                        {name}
                    </MainHeading>
                    <div>
                        <SubHeading className="leader-image-card__sub-header">
                            {position}
                        </SubHeading>
                        {secondary && (
                            <SubHeading className="leader-image-card__sub-header">
                                {secondary}
                            </SubHeading>
                        )}
                    </div>
                </div>
                <SmartLink
                    url={pageUrl}
                    ariaLabel={`View ${name}'s Leadership Bio`}
                    classNames={[`leader-image-card__link`]}
                >
                    View Bio
                    <KiteIcon icon="ki-arrow-right" size="1rem" />
                </SmartLink>
            </div>
        </div>
    );
};
